module.exports = __webpack_public_path__ + "img/lingxingxiao.prt.2f487333.jpg";